import { useEffect } from "react"
import type { RefObject } from "react"

import type { CartUsers } from "@/queries/models"
import { useSkipassStore } from "@/store/skipassStore"
import { buildSelectedProduct, toProductInfo } from "@/utils/productMappers"

import type { ProductWithPrices } from "../utils"

export const useCartUserAutoSelect = (
  productsWithPrices: ProductWithPrices[],
  cartUsers: CartUsers | undefined,
  isPricesLoading: boolean,
  hasAutoSelected: RefObject<boolean> | undefined,
  isProductSelectable?: (productId: string) => boolean
) => {
  const incrementProduct = useSkipassStore((state) => state.incrementProduct)

  useEffect(() => {
    if (
      !hasAutoSelected ||
      hasAutoSelected.current ||
      isPricesLoading ||
      productsWithPrices.length === 0 ||
      !cartUsers
    ) {
      return
    }

    hasAutoSelected.current = true

    const firstProduct = isProductSelectable
      ? productsWithPrices.find((p) => isProductSelectable(p.id))
      : productsWithPrices[0]

    if (!firstProduct) return

    const validAgeGroups = firstProduct.ageGroups.filter(
      (ag) => ag.id !== "-1" && ag.price
    )

    const productInfo = toProductInfo(firstProduct)

    cartUsers.ages.forEach((age) => {
      const matchingAgeGroup = validAgeGroups.find(
        (ag) => age >= ag.minAge && age <= ag.maxAge
      )
      if (matchingAgeGroup) {
        incrementProduct(buildSelectedProduct(productInfo, matchingAgeGroup))
      }
    })
  }, [
    productsWithPrices,
    cartUsers,
    isPricesLoading,
    incrementProduct,
    hasAutoSelected,
    isProductSelectable,
  ])
}
